<template>
  <span>
    <q-icon
      name="edit"
      size="16px"
      color="primary"
      class="ml-1"
    />
    <q-popup-edit
      v-model="payload"
      class="contact-status-updated-at-date-picker"
      buttons
      :persistent="true"
      @save="formatAndEmitDates"
    >
      <div
        v-if="agent.contact_status_updated_at"
        class="bg-grey-3 p-3"
      >
        Current date:
        <SdDatetime
          class="d-block"
          :value="agent.contact_status_updated_at"
          format="MM/DD/YY"
        />
      </div>
      <div>
        <q-datetime
          v-model="payload.contact_status_updated_at"
          float-label="Day"
          minimal
          default-view="day"
          today-btn
          :clear-value="null"
          type="date"
          format="MM/DD/YY"
          format-model="string"
        />
      </div>
    </q-popup-edit>
  </span>
</template>

<script>

export default {
  name: 'AgentContactStatusUpdatedAtDatePicker',
  props: {
    agent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      payload: { contact_status_updated_at: null },
      selectedContactStatusUpdatedAt: null,
    };
  },
  methods: {
    formatAndEmitDates() {
      const dateStr = this.payload.contact_status_updated_at.split(' ')[0];

      if (this.selectedContactStatusUpdatedAt) {
        this.payload.contact_status_updated_at = `${dateStr} ${this.selectedContactStatusUpdatedAt}:00`;
      }

      this.$emit('dates-updated', this.payload);
      this.payload = { contact_status_updated_at: null };
    },
  },
};
</script>
